<template>
  <vl-content-header
    mod-large
    mod-show-mobile
    :background="{
      src: '/img/header-pbs.png',
      alt: 'Content Header'
    }"
    v-bind="{}"
  >
    <div class="vl-content-header__logo-wrapper">
      <vl-content-header-entity
        prefix="Digitaal"
        title="Vlaanderen"
        logo="true"
        href="https://www.vlaanderen.be/"
        mod-small
      />
    </div>
    <vl-content-header-title title="Datapublicatie" tag-name="h1" href="https://datapublicatie.vlaanderen.be/" />
  </vl-content-header>
</template>

<script lang="ts" setup>
import { onMounted } from 'vue';

onMounted(() => {});
</script>

<style lang="scss" scoped></style>
